import React from 'react';

function Alert({ children, ...restProps }) {
    return (
        <>
            <div className="alert alert-danger" {...restProps} role="alert">
                {children}
            </div>
        </>
    );
}

export default Alert;
